function urlBase64ToUint8Array(base64String) {
    const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
    const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
    const raw = window.atob(base64);
    return new Uint8Array([...raw].map((c) => c.charCodeAt(0)));
}

export async function registerAndSubscribePush(api) {
    // Service workers require HTTPS (except on localhost)
    if (location.protocol !== 'https:' && location.hostname !== 'localhost' && location.hostname !== '127.0.0.1') {
        return null;
    }

    if (!('serviceWorker' in navigator) || !('PushManager' in window) || !('Notification' in window)) {
        return null;
    }

    try {
        const reg = await navigator.serviceWorker.register('/sw.js');
        const permission = await Notification.requestPermission();
        if (permission !== 'granted') return null;

        const { key: vapidPublicKey } = await api.get('/push/vapid-public-key');

        const existing = await reg.pushManager.getSubscription();
        if (existing) {
            const json = existing.toJSON();
            await api.post('/push/subscribe', {
                endpoint: json.endpoint,
                p256dh: json.keys.p256dh,
                auth: json.keys.auth,
            });
            return existing;
        }

        const subscription = await reg.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: urlBase64ToUint8Array(vapidPublicKey),
        });

        const json = subscription.toJSON();
        await api.post('/push/subscribe', {
            endpoint: json.endpoint,
            p256dh: json.keys.p256dh,
            auth: json.keys.auth,
        });

        return subscription;
    } catch (err) {
        console.warn('Push subscription failed:', err);
        return null;
    }
}
